export enum UserStatus {
  Active = 'Active',
  Inactive = 'Inactie',
}
export enum UserRole {
  SUPER_ADMIN = 'Super Admin',
  ADMIN = 'Admin',
  MANAGER = 'Manager',
  USER = 'User',
}
export class User {
  userId: string;
  firstName: string;
  lastName: string;
  name: string;
  roles: UserRole[];
  picture?: string | null;
  status: string;
  email: string;
  userRole?: string;
  // Permitted states for this contract. Stored server-side in `user-info`, not on
  // the user row -- resolved onto each row by the users list endpoint.
  state?: string[];
}
